(function () {
  class EbMainCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.bind();
      this.notifyProductCardsUpdated();
    }

    bind() {
      this.form = this.querySelector('[data-eb-facets-form]');
      this.gridWrap = this.querySelector('[data-eb-grid-wrap]');
      this.form?.addEventListener('change', this.debounce(() => this.submitFacets(), 250));
      this.bindPriceRanges();
      this.form?.addEventListener('submit', (event) => {
        if (window.fetch) {
          event.preventDefault();
          this.submitFacets();
        }
      });

      this.querySelector('[data-eb-sort-select]')?.addEventListener('change', (event) => {
        const hidden = this.querySelector('[data-eb-sort-hidden]');
        if (hidden) hidden.value = event.target.value;
        this.submitFacets();
      });

      this.querySelector('[data-eb-facets-open]')?.addEventListener('click', () => this.openFacets());
      this.querySelector('[data-eb-facets-close]')?.addEventListener('click', () => this.closeFacets());
      this.querySelector('[data-eb-facets-apply]')?.addEventListener('click', () => this.closeFacets());
      this.querySelector('[data-eb-load-more]')?.addEventListener('click', (event) => this.loadMore(event));

      window.addEventListener('popstate', () => this.renderUrl(new URL(window.location.href)));
    }

    formUrl() {
      const params = new URLSearchParams(new FormData(this.form));
      [...params.keys()].forEach((key) => {
        const values = params.getAll(key).filter((value) => value !== '');
        params.delete(key);
        values.forEach((value) => params.append(key, value));
      });
      const url = new URL(this.form.action);
      url.search = params.toString();
      return url;
    }

    bindPriceRanges() {
      this.querySelectorAll('[data-eb-price-range]').forEach((range) => {
        const minNumber = range.querySelector('[data-eb-price-min]');
        const maxNumber = range.querySelector('[data-eb-price-max]');
        const minRange = range.querySelector('[data-eb-price-min-range]');
        const maxRange = range.querySelector('[data-eb-price-max-range]');
        const fill = range.querySelector('[data-eb-price-range-fill]');
        const paint = () => {
          if (!fill || !minRange || !maxRange) return;
          const floor = Number(minRange.min || 0);
          const ceiling = Number(maxRange.max || 0);
          const span = ceiling - floor || 1;
          const low = Math.min(Number(minRange.value || floor), Number(maxRange.value || ceiling));
          const high = Math.max(Number(minRange.value || floor), Number(maxRange.value || ceiling));
          fill.style.left = `${((low - floor) / span) * 100}%`;
          fill.style.right = `${100 - ((high - floor) / span) * 100}%`;
        };
        const sync = (source) => {
          let min = Number((source === minRange ? minRange : minNumber)?.value || 0);
          let max = Number((source === maxRange ? maxRange : maxNumber)?.value || maxRange?.max || 0);
          if (min > max) [min, max] = [max, min];
          if (minNumber) minNumber.value = min || '';
          if (maxNumber) maxNumber.value = max || '';
          if (minRange) minRange.value = min;
          if (maxRange) maxRange.value = max;
          paint();
        };
        [minNumber, maxNumber, minRange, maxRange].forEach((input) => {
          input?.addEventListener('input', (event) => sync(event.currentTarget));
          input?.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            window.setTimeout(() => sync(event.currentTarget));
          });
        });
        paint();
      });
    }

    async submitFacets() {
      if (!window.fetch || !this.form) {
        this.form?.submit();
        return;
      }
      const url = this.formUrl();
      window.history.pushState({}, '', url.toString());
      await this.renderUrl(url);
    }

    async renderUrl(url) {
      if (!this.sectionId) return;
      this.gridWrap?.classList.add('is-loading');
      const requestUrl = new URL(url.toString());
      requestUrl.searchParams.set('section_id', this.sectionId);
      const html = await fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((response) => response.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('eb-main-collection');
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      this.bind();
      this.notifyProductCardsUpdated();
    }

    async loadMore(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const link = event.currentTarget;
      const url = new URL(link.href);
      url.searchParams.set('section_id', this.sectionId);
      const html = await fetch(url.toString()).then((response) => response.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html');
      const newCards = fresh.querySelectorAll('[data-eb-product-grid] > *');
      const grid = this.querySelector('[data-eb-product-grid]');
      newCards.forEach((card) => grid?.appendChild(card));
      const next = fresh.querySelector('[data-eb-load-more]');
      if (next) link.href = next.href;
      else link.closest('.eb-collection-load-more')?.remove();
      window.history.replaceState({}, '', link.href);
      this.notifyProductCardsUpdated();
    }

    openFacets() {
      this.classList.add('is-facets-open');
      window.ebScrollLock?.lock();
    }

    closeFacets() {
      const wasOpen = this.classList.contains('is-facets-open');
      this.classList.remove('is-facets-open');
      if (wasOpen) window.ebScrollLock?.unlock();
      if (wasOpen) this.dispatchEvent(new CustomEvent('eb:facets:close', { bubbles: true }));
    }

    notifyProductCardsUpdated() {
      window.dispatchEvent(new CustomEvent('eb:product-cards:updated', { detail: { root: this } }));
    }

    debounce(callback, wait) {
      let timer;
      return (...args) => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => callback(...args), wait);
      };
    }
  }

  if (!customElements.get('eb-main-collection')) customElements.define('eb-main-collection', EbMainCollection);
})();
